// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__WL8KB","containerItemsCenter":"Skeleton_containerItemsCenter__2pS48"};